<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h2 class="content-header-title float-start mb-0">
                Import from WOS
              </h2>
            </div>
          </div>
        </div>
        <div class="content-header-right text-md-end col-md-3 col-12 d-md-block d-none">
          <div class="mb-1 breadcrumb-right">
            <a
              class="btn btn-icon btn-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Back to publications"
              @click="$router.push({name: 'researcher.publications.index'})"
            ><i data-feather="chevron-left" /></a>
            <a
              href="#"
              class="btn btn-icon btn-flat-secondary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Publications settings"
            ><i data-feather="settings" /></a>
          </div>
        </div>
      </div>
      <div class="content-body content-body--senior-call">
        <div class="row">
          <div class="col-12">

            <div class="card card--table">
              <div class="card-header">
                <h3 class="cart-title">
                  <a data-action="collapse">Upload file</a>
                </h3>
              </div>
              <div class="card-content collapse show">

                <div class="card-body">
                  <div class="row">
                    <div class="col">
                      <div class="mb-1">
                        <div
                          class="input-group custom-file-button"
                        >
                          <label
                            class="input-group-text"
                            for="formFile"
                          >Select file</label>
                          <input
                            id="formFile"
                            :ref="`file-import`"
                            class="form-control"
                            type="file"
                          >
                        </div>
                      </div>
                      <div class="mb-1">
                        <button
                          :disabled="checkingDuplicates"
                          class="btn btn-dark"
                          @click="importFile"
                        >
                          <i data-feather="upload-cloud" /> Upload file
                        </button>
                        <button
                          v-if="publications.length > 0"
                          :disabled="checkingDuplicates"
                          class="btn btn-danger ms-1"
                          @click="$store.dispatch('publicationImport/clearItems')"
                        >
                          <i data-feather="x" /> Remove loaded publications
                        </button>
                        <div
                          v-if="checkingDuplicates"
                          class="loading custom-loading mt-1"
                        >
                          <div class="effect-1 effects" />
                          <div class="effect-2 effects" />
                          <div class="effect-3 effects" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <template>
              <div
                v-if="importError"
                class="alert alert-danger"
              >
                <div class="alert-body">
                  <i data-feather="alert-octagon" /> {{ importError }}
                </div>
              </div>

              <div
                v-if="importSkipped.length > 0"
                class="alert alert-warning"
              >
                <div class="alert-body">
                  <i data-feather="alert-triangle" /> <strong>{{ importSkipped.length }}</strong> line{{ importSkipped.length > 1 ? 's' : '' }} in the file could not be read and {{ importSkipped.length > 1 ? 'were' : 'was' }} skipped:
                  <ul class="mb-0 mt-50">
                    <li
                      v-for="skipped in importSkipped.slice(0, maxReportedSkips)"
                      :key="skipped.row"
                    >
                      Line {{ skipped.row }} &mdash; {{ skipped.reason }}
                    </li>
                    <li v-if="importSkipped.length > maxReportedSkips">
                      &hellip; and {{ importSkipped.length - maxReportedSkips }} more
                    </li>
                  </ul>
                </div>
              </div>

              <div
                v-if="ok != 0"
                class="alert alert-success"
              >
                <div class="alert-body">
                  <i data-feather="check-circle" /> <strong>{{ ok }}</strong> publications loaded successfully
                </div>
              </div>

              <div
                v-if="duplicates != 0"
                class="alert alert-danger"
              >
                <div class="alert-body">
                  <i data-feather="alert-triangle" /> <strong>{{ duplicates }}</strong> publications marked as duplicates
                </div>
              </div>

              <div
                v-if="maybes != 0"
                class="alert alert-warning"
              >
                <div class="alert-body">
                  <i data-feather="alert-triangle" /> <strong>{{ maybes }}</strong> publications marked as maybe
                </div>
              </div>

              <div
                v-if="updateds != 0"
                class="alert alert-info"
              >
                <div class="alert-body">
                  <i data-feather="alert-circle" /> <strong>{{ updateds }}</strong> publication identified as updated
                </div>
              </div>

              <CompleteTable
                v-if="!checkingDuplicates"
                :sorted-field="sortedField"
                :data="publications"
                :sort-mapping="sortMapping"
                :title="'publications'"
                :total="publications.length"
                :fetch-path="'publicationImport/fetch'"
                :export-path="'publicationImport/export'"
                :filter-path="'publicationImport/filter'"
                :actions="true"
                :hide-bottom="true"
                @selectedItems="saveSelectedItems"
              >
                <template v-slot="{field}">
                  <td class="text-end">
                    <span
                      class="dis-ib"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Edit area and group"
                    ><a
                      class="btn btn-icon rounded-circle btn-flat-dark"
                      :href="$router.resolve({name: 'admin.publications.import.edit', params: { id: field.wos_id }, query: { actAs: $route.query.actAs }}).href"
                      target="_blank"
                    ><i data-feather="edit-3" /></a></span>
                    <span
                      class="dis-ib"
                      @click="$store.dispatch('publicationImport/delete', field.wos_id)"
                    ><a
                      class="btn btn-icon rounded-circle btn-flat-danger"
                      data-bs-toggle="modal"
                      data-bs-target="#modalDeleteWithInput"
                    ><i data-feather="trash-2" /></a></span>
                  </td>
                </template>
                <template #customfilters>
                  <div class="mb-1">
                    <label
                      for="nameseniorcall"
                      class="form-label"
                    >WOS ID</label>
                    <input
                      type="text"
                      class="form-control"
                      name="nameseniorcall"
                      @change="saveFilter($event.target.value, 'wos_id')"
                    >
                  </div>
                  <div class="mb-1">
                    <label
                      for="nameseniorcall"
                      class="form-label"
                    >Title</label>
                    <input
                      type="text"
                      class="form-control"
                      name="nameseniorcall"
                      @change="saveFilter($event.target.value, 'title')"
                    >
                  </div>
                  <div class="mb-1">
                    <label
                      for="nameseniorcall"
                      class="form-label"
                    >Year</label>
                    <input
                      type="text"
                      class="form-control"
                      name="nameseniorcall"
                      @change="saveFilter($event.target.value, 'year')"
                    >
                  </div>
                  <div class="mb-1">
                    <label
                      for="nameseniorcall"
                      class="form-label"
                    >Journal</label>
                    <input
                      type="text"
                      class="form-control"
                      name="nameseniorcall"
                      @change="saveFilter($event.target.value, 'journal')"
                    >
                  </div>
                  <div class="mt-1 mb-1">
                    <label
                      for=""
                      class="form-label"
                    >Duplicated</label>
                    <select
                      class="form-select select2"
                      @change="saveFilter($event.target.value, 'duplicated')"
                    >
                      <option
                        selected
                        disabled
                        value=""
                      >
                        Select one option
                      </option>
                      <option value="0">
                        No
                      </option>
                      <option value="1">
                        Yes
                      </option>
                      <option value="2">
                        Updated
                      </option>
                      <option value="3">
                        Maybe
                      </option>
                    </select>
                  </div>
                </template>
                <template #info-sheet-item>
                  <div class="offcanvas-body offcanvas-body--view">

                    <h4 class="mb-2">
                      <strong class="text-success">{{ selectedItems.length }}</strong> selected imported publications
                    </h4>

                    <div class="mt-1 mb-1">
                      <label
                        for=""
                        class="form-label"
                      >Select publications (Duplicated column)</label>
                      <select
                        class="form-select select2"
                        @change="selectData($event)"
                      >
                        <option
                          selected
                          disabled
                          value=""
                        >
                          Select one option
                        </option>
                        <option value="0">
                          No
                        </option>
                        <option value="1">
                          Yes
                        </option>
                        <option value="2">
                          Updated
                        </option>
                        <option value="3">
                          Maybe
                        </option>
                      </select>
                    </div>

                    <ul
                      id="basic-list-group"
                      class="list-group"
                    >
                      <li class="list-group-item draggable">
                        <div class="d-flex">
                          <div class="more-info">
                            <div class="form-check">
                              <input
                                id="tableAction1"
                                v-model="actions.convertToPubli"
                                type="checkbox"
                                class="form-check-input"
                              >
                              <label
                                class="form-check-label"
                                for="tableAction1"
                              >Convert WOS to publication</label>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="list-group-item draggable">
                        <div class="d-flex">
                          <div class="more-info">
                            <div class="form-check">
                              <input
                                id="tableAction2"
                                v-model="actions.convertToPubliSigned"
                                type="checkbox"
                                class="form-check-input"
                              >
                              <label
                                class="form-check-label"
                                for="tableAction2"
                              >Convert WOS to publication (signed as ICREA)</label>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="list-group-item draggable">
                        <div class="d-flex">
                          <div class="more-info">
                            <div class="form-check">
                              <input
                                id="tableAction4"
                                v-model="actions.deleteItem"
                                type="checkbox"
                                class="form-check-input"
                              >
                              <label
                                class="form-check-label"
                                for="tableAction4"
                              >Delete item</label>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="list-group-item draggable">
                        <div class="d-flex">
                          <div class="more-info">
                            <div class="form-check">
                              <input
                                id="tableAction5"
                                v-model="actions.deleteDuplicates"
                                type="checkbox"
                                class="form-check-input"
                              >
                              <label
                                class="form-check-label"
                                for="tableAction5"
                              >Delete duplicates</label>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li class="list-group-item draggable">
                        <div class="d-flex">
                          <div class="more-info">
                            <div class="form-check">
                              <input
                                id="tableAction6"
                                v-model="actions.updatedPubli"
                                type="checkbox"
                                class="form-check-input"
                              >
                              <label
                                class="form-check-label"
                                for="tableAction6"
                              >Update publication</label>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="offcanvas-footer mt-auto">
                    <a
                      title="apply actions"
                      class="btn btn-primary mb-1 d-grid w-100"
                      @click="applyActions"
                    >Apply actions</a>
                  </div>
                </template>
              </CompleteTable>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import CompleteTable from '../../partials/components/CompleteTable.vue'

// Two-letter field codes we read from a Web of Science "Tab delimited" export.
// Without these the file cannot be mapped at all, so the import is aborted
// instead of silently producing an empty or misaligned result.
const WOS_REQUIRED_CODES = ['UT', 'TI', 'AU', 'DT', 'SO', 'PY']

export default {
  components: {
    CompleteTable,
  },
  data() {
    return {
      checkingDuplicates: false,
      status: 0,
      importError: null,
      importSkipped: [],
      // Skipped lines detailed in the warning before summarising the rest.
      maxReportedSkips: 5,
      selectedItems: [],
      actions: {
        convertToPubli: false,
        convertToPubliSigned: false,
        deleteItem: false,
        deleteDuplicates: false,
      },
      sortedField: 'Order',
      defaultFields: [
        {
          name: 'Wos Id',
          checked: true,
          order: 1,
        },
        {
          name: 'Title',
          checked: true,
          order: 2,
        },
        {
          name: 'Year',
          checked: true,
          order: 3,
        },
        {
          name: 'Journal',
          checked: true,
          order: 4,
        },
        {
          name: 'Duplicated',
          checked: true,
          order: 5,
        },
        {
          name: 'Authors',
          checked: true,
          order: 6,
        },
        {
          name: 'Type',
          checked: true,
          order: 7,
        },
      ],
      sortMapping: {
        'Wos Id': 'wos_id',
        Title: 'title',
        Year: 'year',
        Journal: 'publication_name',
        Duplicated: 'duplicated_table',
        Authors: 'authors',
        Type: 'publication_type',
      },
    }
  },
  computed: {
    ...mapGetters({
      fields: 'modals/tableSettingsFields',
      publications: 'publicationImport/items',
      updateds: 'publicationImport/updateds',
      duplicates: 'publicationImport/duplicates',
      ok: 'publicationImport/ok',
      maybes: 'publicationImport/maybes',
      filters: 'filters/filters',
    }),
  },
  async mounted() {
    window.onfocus = async () => {
      if (!this.checkingDuplicates) {
        this.checkingDuplicates = true
        await this.$store.dispatch('publicationImport/loadPublications', this.filters)
        setTimeout(() => {
          this.checkingDuplicates = false
        }, 200)
      }
    }
    await this.$store.dispatch('publicationImport/loadPublications', this.filters)
    this.items = this.itemsImported
    await this.$store.dispatch('modals/fetchUserFields', 'publications-import')
    if (!this.fields || this.fields.length === undefined) { // If user doesnt have default fields, load the true default
      await this.$store.dispatch('modals/fetchFields', {
        fields: this.defaultFields,
        table: 'publications-import',
      })
    }
    setTimeout(() => {
      feather.replace({
        width: 14,
        height: 14,
      })
    }, 500)
  },
  methods: {
    async importFile() {
      this.checkingDuplicates = true
      this.importError = null
      this.importSkipped = []

      const file = this.$refs['file-import'].files[0]
      if (!file) {
        this.checkingDuplicates = false
        this.status = 0
        this.importError = 'Select a Web of Science export file first.'
        return
      }

      // FileReader Object
      const reader = new FileReader()

      reader.onerror = () => {
        this.checkingDuplicates = false
        this.status = 0
        this.importError = `The file could not be read (${reader.error ? reader.error.name : 'unknown error'}).`
      }

      // Load event. Note this runs asynchronously: a throw in here would escape
      // any try/catch wrapping readAsText, so the whole body is guarded.
      reader.onload = event => {
        try {
          const { items, skipped } = this.parseWosExport(event.target.result)
          this.importSkipped = skipped

          if (!items.length) {
            this.checkingDuplicates = false
            this.status = 0
            this.importError = 'No publication could be read from this file.'
            return
          }

          this.$store.dispatch('publicationImport/saveItems', items).then(() => {
            this.checkingDuplicates = false
            feather.replace({
              width: 14,
              height: 14,
            })
          }).catch(e => {
            console.log(e)
            this.checkingDuplicates = false
            this.status = 0
            this.importError = 'The publications could not be checked against the database. Please try again.'
          })
          this.status = 1
        } catch (e) {
          console.log(e)
          this.checkingDuplicates = false
          this.status = 0
          this.importError = e.message
        }
      }

      // Read file as string
      reader.readAsText(file)
    },
    // Web of Science reorders the columns of its tab-delimited exports without
    // warning: two exports with the very same 71 fields had UT at index 70 and
    // at index 66 respectively, and index 70 held DA (the export date) in the
    // second one. Every field is therefore looked up by its two-letter code and
    // never by a fixed position, and the values that end up in a typed column
    // are validated here so they can never reach Postgres as garbage.
    parseWosExport(content) {
      // Exports are UTF-8, sometimes with a BOM and sometimes with CRLF (both
      // variants show up in real files). Strip the BOM so the first header code
      // is not read as "\uFEFF" + "PT", and split on any line ending so the last cell
      // of a row does not keep a trailing "\r" (UT used to be the last column,
      // which made every accession number fail an all-digits check).
      const rows = content
        .replace(/^\uFEFF/, '')
        .split(/\r\n|\r|\n/)
        .filter(row => row.trim() !== '')

      if (!rows.length) {
        throw new Error('The file is empty.')
      }

      const col = {}
      rows[0].split('\t').forEach((code, i) => {
        const key = code.trim()
        if (key !== '' && !(key in col)) {
          col[key] = i
        }
      })

      const missing = WOS_REQUIRED_CODES.filter(code => !(code in col))
      if (missing.length) {
        throw new Error(`This does not look like a Web of Science "Tab delimited" export: the header row has no ${missing.join(', ')} field${missing.length > 1 ? 's' : ''}. Export the records again choosing "Full Record".`)
      }

      const items = []
      const skipped = []

      for (let row = 1; row < rows.length; row++) {
        const cells = rows[row].split('\t')
        // Reading by code keeps a missing or shifted column from silently
        // resolving to whatever value happens to sit at that index.
        const cell = code => (col[code] === undefined ? '' : (cells[col[code]] || '').trim())

        // UT is the accession number ("WOS:000123456700001") and feeds the
        // bigint wos_id column; PY feeds the integer year column. Anything else
        // would reach Postgres as SQLSTATE 22P02 and fail the whole request.
        const wosId = cell('UT').replace(/^WOS:/i, '')
        const year = cell('PY')

        if (!/^\d{1,18}$/.test(wosId)) {
          skipped.push({ row: row + 1, reason: `UT is not a WoS accession number (found "${this.truncateValue(cell('UT'))}")` })
        } else if (year !== '' && !/^\d{4}$/.test(year)) {
          skipped.push({ row: row + 1, reason: `PY is not a four-digit year (found "${this.truncateValue(year)}")` })
        } else {
          const item = {
            wos_id: wosId,
            // DL is the DOI link used as an href; DI is the bare DOI.
            doi: cell('DL') || (cell('DI') ? `https://doi.org/${cell('DI')}` : ''),
            title: cell('TI'),
            authors: cell('AU'),
            publication_type: cell('DT'),
            publication_name: this.capitalizeFirstLetter(cell('SO').toLowerCase()),
            noservol_pages: `${cell('VL')} - ${cell('IS')} - ${cell('BP')} - ${cell('EP')}${cell('AR') ? ` - ${cell('AR')}` : ''}`,
            year,
            duplicated: false,
            has_early_access: cell('DT').includes('Early Access'),
            users: [],
          }
          items.push({
            ...item,
            full_reference: this.getReference(item),
          })
        }
      }

      return { items, skipped }
    },
    truncateValue(value, max = 40) {
      return value.length > max ? `${value.slice(0, max)}…` : value
    },
    getReference(publication) {
      let link = ''
      link = `'<a href="${publication.doi}">${publication.title}</a>', <em>${publication.publication_name}</em>`
      return `${publication.authors.length > 250 ? `${publication.authors.split(';')[0]} et al.` : publication.authors.replaceAll(',', '').replaceAll(';', ',')} ${publication.year}, ${link}, ${publication.noservol_pages ?? (publication.wos_data && publication.wos_data.noservol_pages ? publication.wos_data.noservol_pages : '')}.`
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    saveFilter(value, field) {
      this.$store.dispatch('filters/saveFilters', {
        value,
        field,
      })
    },
    async onSearch(search, store) {
      search.active = true
      if (search.name !== '') {
        await this.$store.dispatch(store, search)
      }
    },
    applyActions() {
      const outside = this
      Vue.swal({
        title: 'Perform the following actions on the selected publications?',
        html: this.getActionsString(),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Yes, apply!',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch('publicationImport/applyActions', { actions: this.actions, items: this.selectedItems }).then(() => {
            this.checkingDuplicates = true
            this.$store.dispatch('modals/toggleInfoItemSheet', false)
            this.$toastr.success('', 'Actions applied successfully!')
            this.$store.dispatch('publicationImport/loadPublications')
            setTimeout(() => {
              this.checkingDuplicates = false
            }, 200)
          })
        } else if (this.selectedItems.length === 0) {
          this.$toastr.error('', 'No items selected!')
        }
      })
    },
    saveSelectedItems(items) {
      this.selectedItems = items
    },
    getActionsString() {
      let str = ''

      if (this.actions.convertToPubli) {
        str += '<p class="text-success">Convert WOS to publication</p>'
      }

      if (this.actions.convertToPubliSigned) {
        str += '<p class="text-success">Convert WOS to publication and signed by Icrea</p>'
      }

      if (this.actions.deleteItem) {
        str += '<p class="text-warning">Delete item</p>'
      }

      if (this.actions.deleteDuplicates) {
        str += '<p class="text-warning">Delete duplicates</p>'
      }

      return str
    },
    selectData(event) {
      const data = this.publications.filter(e => e.duplicated === parseInt(event.target.value, 0))
      this.selectedItems = data
    },
  },
}
</script>
